module.exports = __webpack_public_path__ + "img/update_device.2dd038ed.png";